/**
 * Gráfico de uma referência da resposta do assistente — Nexora Grid (US-3203).
 *
 * Criado em: 26/10/2026 · Última modificação: 26/10/2026 · Versão: 1.0.0
 *
 * `/cco/grafico?device=…&medida=…&de=<ms>&ate=<ms>`: aberto ao clicar num número da resposta do agente. Mostra o
 * painel da medida do dashboard "CCO · Assistente" (Grafana, só leitura) para o ponto e a janela que o agente consultou.
 * Medida sem painel pronto: só o link para o equipamento.
 */
import { Link, useSearchParams } from "react-router-dom";
import { useCco } from "./contexto";
import { PainelGrafana } from "./PainelGrafana";

const PAINEL: Record<string, [number, string]> = { nivel: [1, "nível"], pressao: [2, "pressão"], vazao: [3, "vazão"], potencia: [4, "potência"] };

export function GraficoReferencia() {
  const { empresa } = useCco();
  const [q] = useSearchParams();
  const device = q.get("device") ?? "";
  const medida = q.get("medida") ?? "";
  const de = q.get("de") ?? "now-6h";
  const ate = q.get("ate") ?? "now";
  const painel = Object.entries(PAINEL).find(([prefixo]) => medida.startsWith(prefixo))?.[1];
  if (!empresa || !/^[A-Za-z0-9][A-Za-z0-9._:-]{0,99}$/.test(device)) return <p className="nx-suave">Referência inválida.</p>;
  const janela = /^\d+$/.test(de) && /^\d+$/.test(ate)
    ? `${new Date(Number(de)).toLocaleString("pt-BR")} → ${new Date(Number(ate)).toLocaleString("pt-BR")}` : `${de} → ${ate}`;
  return (
    <section className="nx-cartao tendencias-pagina" aria-label="Gráfico da referência">
      <h3>{device.toUpperCase()} · {medida.replace(/_/g, " ")} <span className="nx-suave">{janela}</span>
        <Link to={`/cco/equipamento/${device}`} className="nx-botao">Abrir o equipamento</Link></h3>
      {painel ? <PainelGrafana empresa={empresa} uid="nexora-cco-assistente" painel={painel[0]} titulo={`${device} · ${painel[1]}`}
        de={de} ate={ate} variaveis={{ dispositivos: device }} altura={420} />
        : <p className="nx-suave">Não há gráfico pronto para esta medida; abra o equipamento para ver as leituras.</p>}
    </section>
  );
}
